export const LOAD_TIMEOUT_MS = 15000;
export const DEFAULT_ERROR_MESSAGE =
  "Failed to load notifications. Please try again.";
export const LOAD_TIMEOUT_MESSAGE =
  "Loading notifications is taking longer than expected. Please try again.";
